import React, { useMemo, useEffect, useState } from "react";
import { Button, Input, Select, Table, Card, Row, Col, Tag, Modal } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { AiOutlineCheckCircle } from "react-icons/ai";
import debounce from "lodash.debounce";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { productActions } from "../../store";
import categoryApi from "../../api/product/categoryApi";

import { LocalImage } from "../ImageUtil";

const ProductSelectOrder = ({ onSelected }) => {
  const { Option } = Select;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [lstCategory, setLstCategory] = useState([]);

  const [inputFilter, setFilter] = useState({
    keyword: null,
    category: null,
    published: true,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });
  const { lstProduct, totalCountProducts, productSelectOrder } = useSelector(
    (x) => x.product
  );

  const [tags, setTags] = useState([]);

  useEffect(() => {
    getProducts();
    getCategories();
    dispatch(productActions.setProductSelectOrder([]));
  }, [inputFilter]);

  useEffect(() => {
    dispatch(productActions.setProductSelectOrder(tags));
  }, [tags]);

  const getCategories = () => {
    const params = {
      display: true,
      page: 1,
      limit: 10000,
    };
    categoryApi.getCategories(params).then((res, status) => {
      if (res.results) {
        const data = res.results;
        setLstCategory(data);
      }
    });
  };

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, keyword: e.target.value });
  };

  const getProductsDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getProducts = () => {
    setLoading(true);
    dispatch(productActions.getProducts(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";

    if (sorter && sorter.columnKey) {

      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      keyword: inputFilter.keyword,
      sortBy: sort,
      category: inputFilter.category,
      published: inputFilter.published,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    // {
    //   title: "STT",
    //   render: (text, record, index) => (page - 1) * pageSize + index + 1,
    //   className: "text-center",
    //   width: "5%",
    // },
    {
      title: "Ảnh hiển thị",
      dataIndex: "avatar",
      key: "avatar",
      render: (avatar) => (
        <>
          <LocalImage
            src={avatar}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: "15%",
      className: "text-center",
    },
    {
      title: "Tên sản phẩm",
      dataIndex: "name",
      render: (text) => <h3>{text}</h3>,
      width: "30%",
    },
    // {
    {
      title: "Danh mục",
      dataIndex: "category",
      render: (category) => <label>{category?.name}</label>,
      width: "25%",
    },
    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <>
          <Button
            onClick={() => addProduct(record)}
            value="large"
            icon={<AiOutlineCheckCircle />}
          >
            &nbsp; Chọn sản phẩm
          </Button>
        </>
      ),
      className: "text-center",
      width: 50,
    },
  ];

  const addProduct = (record) => {
    const isPromotions = record.promotions.length > 0;
    const price = isPromotions ? record.salePrice : record.price;
    const data = {
      ...record,
      priceFinal: record.price,
      salePriceFinal: record.salePrice,
      isPromotions: isPromotions,
      quantity: 1,
      originPrice: price,
      totalPrice: price,
      idTypeSelect : null,
    };
    const check = tags.filter((x) => x.id === data.id).length;

    if (check === 0) {
      setTags([...tags, data]);

      toast.success("Đã chọn sản phẩm này!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
      });
    } else {
      toast.warning("Sản phẩm này đã được chọn!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
      });
    }
  };

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
    toast.info("Đã xóa sản phẩm này!", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      progress: undefined,
    });
  };

  const forMap = (tag) => {
    const tagElem = (
      <Tag
        className="my-tag"
        color="#87d068"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag.name}
      </Tag>
    );
    return (
      <span
        key={tag.id}
        style={{
          display: "inline-block",
        }}
      >
        {tagElem}
      </span>
    );
  };

  const tagChild = tags.map(forMap);

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên hoặc SKU sản phẩm</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                // value={inputFilter.username}
                placeholder="Nhập tên hoặc SKU sản phẩm..."
                onChange={getProductsDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6}>
              <label className="">Danh mục</label>
              <Select
                defaultValue={inputFilter.category}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter, category: e });
                }}
              >
                <Option value="">---Mặc định---</Option>
                {lstCategory == null ||
                lstCategory === "undefined" ||
                lstCategory === []
                  ? []
                  : lstCategory.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
              </Select>
            </Col>
          </Row>
        </Card>

        <br />
        <Card>
          <div
            style={{
              marginBottom: 0,
            }}
          >
            <label>Sản phẩm đã chọn : </label> &nbsp;
            {tagChild}
          </div>
        </Card>
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 ">
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstProduct}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCountProducts,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
              scroll={{
                y: 250,
              }}
            />
          </div>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default ProductSelectOrder;
